import { StrictMode, useCallback, useEffect, useState } from "react";
import {
  createBrowserRouter,
  Outlet,
  RouterProvider,
  useLocation,
} from "react-router-dom";
import { createRoot } from "react-dom/client";
import Cookies from "universal-cookie";

// Components
import NotFound from "@/pages/NotFound";
import { I18nextProvider } from "react-i18next";

// internationalization
import global_en from "@/translation/En/global.json";
import global_es from "@/translation/Es/global.json";
import errors_en from "@/translation/En/errors.json";
import errors_es from "@/translation/Es/errors.json";
import homeowners_en from "@/translation/En/homeowners.json";
import homeowners_es from "@/translation/Es/homeowners.json";
import i18next from "i18next";

import { HomeownersHeader } from "@/components/HomeownersHeader";
import { HomeownersFooter } from "@/components/HomeownersFooter";
import "./index.css";

// pages
import ForHomeownersPage from "@/pages/ForHomeowners";
import HomeownersLegalPage from "@/pages/HomeownersLegal";
import HomeownersContactPage from "@/pages/HomeownersContact";
import { ComingSoonContext } from "@/contexts/ComingSoonContext";
import { ComingSoonModal } from "@/components/ComingSoonModal";

const cookies = new Cookies();

const DEFAULT_LANGUAGE = "en";

i18next.init({
  interpolation: { escapeValue: false },
  lng: cookies.get("lang") || DEFAULT_LANGUAGE,
  resources: {
    es: {
      global: global_es,
      errors: errors_es,
      homeowners: homeowners_es,
    },
    en: {
      global: global_en,
      errors: errors_en,
      homeowners: homeowners_en,
    },
  },
});

const Layout = () => {
  const location = useLocation();
  const pathname = location?.pathname;
  const [comingSoonOpen, setComingSoonOpen] = useState(false);

  const openComingSoonModal = useCallback(() => setComingSoonOpen(true), []);

  useEffect(() => {
    scrollTo({
      top: 0,
      behavior: "instant",
    });
  }, [pathname]);

  return (
    <ComingSoonContext.Provider value={{ openComingSoonModal }}>
      <div className="flex flex-col min-h-screen">
        <HomeownersHeader />

        <div className="flex-1 flex">
          <Outlet />
        </div>
        <HomeownersFooter />
      </div>
      <ComingSoonModal
        open={comingSoonOpen}
        onClose={() => setComingSoonOpen(false)}
      />
    </ComingSoonContext.Provider>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        path: "",
        element: <ForHomeownersPage />,
      },
      {
        path: "legal",
        element: <HomeownersLegalPage />,
      },
      {
        path: "contact",
        element: <HomeownersContactPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nextProvider i18n={i18next}>
      <RouterProvider router={router} />
    </I18nextProvider>
  </StrictMode>
);
